<template>
<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 12V15.3333C16 15.7754 15.8244 16.1993 15.5118 16.5118C15.1993 16.8244 14.7754 17 14.3333 17H2.66667C2.22464 17 1.80072 16.8244 1.48816 16.5118C1.17559 16.1993 1 15.7754 1 15.3333V12M12.334 5.16667L8.16732 1M8.16732 1L4.00065 5.16667M8.16732 1V11" stroke="#8A55F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>
